export const HOME_PAGE = 'landing_main'
export const ANALYTIC_HEADER = 'landing_header'
export const ANALYTIC_PREMIUM = 'premium'
export const ANALYTIC_DASHBOARD = 'dashboard'
export const ANALYTIC_ADS = 'ads'
export const ANALYTIC_LOGIN = 'login'
export const ANALYTIC_REGISTER = 'register'
export const ANALYTIC_HELP = 'help'
export const ANALYTIC_FAVORITES = 'favorites'
export const ANALYTIC_PARTNERS = 'partners'
export const SESSIONS = 'sessions'
export const ANALYTIC_OFFER = 'offer'

export const ANALYTIC_FIRST_SESSION = 'first_session'
export const ANALYTIC_ACCOUNT = 'account'
export const ANALYTIC_SEARCH = 'search'
export const ANALYTIC_DETAILS = 'details'
export const TUTORIAL = 'new_tutorial'
